// extracted by mini-css-extract-plugin
export default {"shimmer":"shimmer_shimmer__Z8KXN","placeHolderShimmer":"shimmer_placeHolderShimmer__eqdV4"};